import React from 'react';
import { getStrings } from '@/helpers/utils';
import Title from '../../components/Title';

export default function PageTitle() {
  const [
    {
      Onboarding: { Step2 },
    },
  ] = getStrings();

  return <Title title={Step2.Header} subTitle={Step2.Subheader} />;
}
